import {useApi} from "../Api";
import {ExcessResponse} from "../types/excess";

export const useExcessRepository = () => {
    const {GET} = useApi();

    const PATH = "/pricing/excess";

    function getExcesses(): Promise<ExcessResponse[]> {
        return GET(`${PATH}/list`);
    }

    return {
        getExcesses
    };
};
